import {
    Avatar,
    Card,
    Divider,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Typography,
} from "@mui/material";
import React from "react";

function CardInformation({ data, ContractsCost, type }) {
    const getName = () => {
        if (type === "user") {
            return data?.name;
        } else {
            return data?.first_name + " " + data?.last_name;
        }
    };

    return (
        <>
            <Card sx={{ padding: "10px" }}>
                <List
                    sx={{
                        width: "100%",
                        bgcolor: "background.paper",
                    }}
                >
                    <ListItem alignItems="flex-start">
                        <ListItemAvatar>
                            <Avatar alt={data?.name} src={data?.image_path} />
                        </ListItemAvatar>
                        <ListItemText
                            primary={`${type.toUpperCase()} Info`}
                            secondary={
                                <>
                                    <Typography
                                        sx={{
                                            display: "inline",
                                        }}
                                        component="span"
                                        variant="h6"
                                        color="text.primary"
                                    >
                                        Name : {getName()}
                                    </Typography>
                                    <br></br>
                                    <Typography
                                        sx={{
                                            display: "inline",
                                        }}
                                        component="span"
                                        variant="h6"
                                        color="text.primary"
                                    >
                                        Email : {data?.email}
                                    </Typography>
                                    <br></br>
                                    <Typography
                                        sx={{
                                            display: "inline",
                                        }}
                                        component="span"
                                        variant="h6"
                                        color="text.primary"
                                    >
                                        Phone : {data?.phone}
                                    </Typography>
                                    {type === "user" && (
                                        <>
                                            <br></br>
                                            <Typography
                                                sx={{
                                                    display: "inline",
                                                }}
                                                component="span"
                                                variant="h6"
                                                color="text.primary"
                                            >
                                                PPW : {data?.ppw}
                                            </Typography>
                                        </>
                                    )}
                                    {type === "user" && (
                                        <>
                                            <br></br>
                                            <Typography
                                                sx={{
                                                    display: "inline",
                                                }}
                                                component="span"
                                                variant="h6"
                                                color="text.primary"
                                            >
                                                Address : {data?.address}
                                            </Typography>
                                        </>
                                    )}
                                    <br></br>
                                    <Typography
                                        sx={{
                                            display: "inline",
                                        }}
                                        component="span"
                                        variant="h6"
                                        color="text.primary"
                                    >
                                        Total Contracts Cost : {ContractsCost} $
                                    </Typography>
                                </>
                            }
                        />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                </List>
            </Card>
        </>
    );
}

export default CardInformation;
